import { useState, useCallback } from 'react';

export const useSearch = () => {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [totalPages, setTotalPages] = useState(0);
  const [totalResults, setTotalResults] = useState(0);

  const searchArticles = useCallback(async (query, page = 1, limit = 10) => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(
        `https://xibarubamback.onrender.com/articles/search?query=${query}&page=${page}&limit=${limit}`
      );
      if (!response.ok) throw new Error('Erreur lors de la recherche');
      const data = await response.json();

      setResults(data.articles || []);
      setTotalPages(data.totalPages || 0);
      setTotalResults(data.total || 0);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  const clearResults = useCallback(() => {
    setResults([]);
    setTotalPages(0);
    setTotalResults(0);
    setError(null);
  }, []);

  return {
    results,
    loading,
    error,
    totalPages,
    totalResults,
    searchArticles,
    clearResults
  };
};
